module.exports = __webpack_public_path__ + "img/kl8lhc_icon.f1184e7f.png";